<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
      
      </div>
      <!-- /Breadcrumb -->

      <employee-onboarding-documents mode="self" />

      <employee-top></employee-top>

      <attendence-employee></attendence-employee>

      <employee-task></employee-task>

      <!-- <employee-performance></employee-performance>

      <team-member></team-member> -->
    </div>
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="#" @click.prevent class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <employee-dashboard-modal></employee-dashboard-modal>
  <!-- /Page Wrapper -->
</template>
<script>
import { ref } from "vue";
import EmployeeOnboardingDocuments from "@/components/hrm/employee-onboarding-documents.vue";
const currentDate = ref(new Date());
export default {
  components: { EmployeeOnboardingDocuments },
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      title: "Employee Dashboard",
      text: "Dashboard",
      text1: "Employee Dashboard",
      isCollapsed: false,
    };
  },
  methods: {
    toggleCollapse() {
      // Toggle the collapsed state
      this.isCollapsed = !this.isCollapsed;

      // Optionally add/remove class on body to collapse header globally
      if (this.isCollapsed) {
        document.body.classList.add("header-collapse");
      } else {
        document.body.classList.remove("header-collapse");
      }
    },
  },
};
</script>

